<template>
  <div id="app">
    <!-- 设置:key="$route.fullPath"，是为了点击重复路由时，url参数不同可以刷新 -->
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue